import React, { FC } from "react";
import { classNames, wrapClick } from "utils";

type ModalTabItem = {
  name: string;
  href: string;
};

type Props = {
  tabs: ModalTabItem[];
  setOrderStatus: (href: string) => void;
  orderStatus: string;
};

const ModalTabs: FC<Props> = ({ tabs, setOrderStatus, orderStatus }) => {
  return (
    <>
      {/* <div className="block mb-2">
                <div className=" bg-card-200 px-6">
                    <nav
                        className="-mb-px flex space-x-8 items-center"
                        aria-label="Tabs"
                    >
                        {tabs.map((_orderStatus) => (
                            <button
                                key={_orderStatus.name}
                                onClick={wrapClick(() => setOrderStatus(_orderStatus.href))}
                                className={classNames(
                                    orderStatus === _orderStatus.href
                                        ? "border-card-500 text-header-300"
                                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200",
                                    "whitespace-nowrap flex py-4 px-1 border-b-2 font-medium text-sm"
                                )}
                                aria-current={
                                    orderStatus === _orderStatus.href ? "page" : undefined
                                }
                            >
                                {_orderStatus.name}
                            </button>
                        ))}
                    </nav>
                </div>
            </div> */}
      <div className="block">
        <div className="border-b border-gray-200 bg-white px-6">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs?.map((_orderTab) => (
              <button
                key={_orderTab?.href}
                onClick={() => setOrderStatus(_orderTab?.href || "")}
                className={classNames(
                  orderStatus === _orderTab?.href
                    ? "border-primary-500 text-primary-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200",
                  "whitespace-nowrap disabled:cursor-not-allowed flex py-4 px-1 border-b-2 font-medium text-sm"
                )}
                aria-current={
                  orderStatus === _orderTab?.href ? "page" : undefined
                }
              >
                {_orderTab?.name}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
};

export default ModalTabs;
